import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";
import Spinner from "../../../Components/Spinner/Spinner";
import axios from "axios";
import baseUrl from "../../../baseUrl";
import { useParams } from "react-router-dom";
import moment from "moment";
import Question from "../../../Components/Admin/Question/Question";
import AddStudentToBatch from "../../../Components/Admin/Students/AddStudentToBatch";

const BatchDetails = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const { id } = useParams();

  const [batch, setBatch] = useState([]);
  const [loading, setLoading] = useState(false);

  //   list the div of the single batch
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/get-batch-details/${id}`, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.success === true) {
          setBatch(res.data.batch);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      {loading && <Spinner />}

      <div>
        <section className="text-gray-700">
          <h3 className="text-gray-700 text-3xl font-bold">Batch Details</h3>
          <hr />
          <BreadCrumb
            textOne="Dashboard"
            linkOne="/admin/dashboard"
            textTwo="Students"
            linkTwo="/admin/students"
            textThree="Batch Details"
          />

          <div className="container px-5 py-5 mx-auto">
            <div className="text-center mb-10">
              <h1 className="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">
                Batch Details of {batch.batchName}
              </h1>
            </div>
            <div className="flex justify-center lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
              <div className="w-full lg:w-1/2 px-4 py-2">
                <div className="mb-4 cursor-pointer">
                  <div className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                    Batch ID
                  </div>
                  <span className="ml-4">{batch._id}</span>
                </div>
                <div className="mb-4 cursor-pointer">
                  <div className="font-semibold bg-gray-200 rounded-md py-2 px-4">
                    Batch Name
                  </div>
                  <span className="ml-4">{batch.batchName}</span>
                </div>
                <div className="mb-4 cursor-pointer">
                  <div className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                    batch Created At
                  </div>
                  <span className="ml-4">
                    {moment(batch.createdAt).fromNow()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <hr />
      <AddStudentToBatch batchName={batch.batchName} />
    </>
  );
};

export default BatchDetails;
